var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#grid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212221",
    fillRule: "evenodd",
    d: "M0 5.25h5.25V0H0zM7.875 21h5.25v-5.25h-5.25zM0 21h5.25v-5.25H0zm0-7.875h5.25v-5.25H0zm7.875 0h5.25v-5.25h-5.25zM15.75 0v5.25H21V0zM7.875 5.25h5.25V0h-5.25zm7.875 7.875H21v-5.25h-5.25zm0 7.875H21v-5.25h-5.25z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "grid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v21H0z"
  })))));
};
export default SvgGrid;